import { render } from "./payBills.vue?vue&type=template&id=e72d4912&scoped=true&ts=true"
import script from "./payBills.vue?vue&type=script&lang=ts"
export * from "./payBills.vue?vue&type=script&lang=ts"

import "./payBills.vue?vue&type=style&index=0&id=e72d4912&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e72d4912"]])

export default __exports__